import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Upload, Button, Icon, Modal } from 'antd';
const FormItem = Form.Item;
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun";
import { SgiEventHandler } from './SgiEventHandler';
import { uuid } from 'rt-sd-common/sgiCommon/sgiCommon';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';

const Dragger = Upload.Dragger;

class SgiFormUpload extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);
        //初始化state属性
        this.initState();
        this.state.buttonProps = { //自定义的
            style: { width: "100%" },
        };
        this.state.types = [];
        this.state.previewVisible = false;//预览可见标志
        this.state.previewImage = "";//预览图片路径
        this.state.previewAlt = "example";//预览图片提示
        this.state.isButton = false;
    }


    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {对象工厂} objFct
     * @param {make类型} type
     */
    upload_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.buttonProps);
        //转换form公共属性
        AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        setFormCtlLayout(moduleDesc, this.formItemProps, this.state.inputprops);
        //绑定值
        bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        this.bindEvent(moduleDesc, objFct, this.state.inputprops, this.state.functions, type);
    }
    bindEvent(moduleDesc, objFct, inputprops, functions, type) {
        bindEvent(this, moduleDesc, objFct, inputprops, functions, type);
        //重写修改事件
        var chgLsn = moduleDesc.chgLsn; // 用户自定义点击事件
        if (chgLsn) {
            var $chgLsn;
            try {
                $chgLsn = new Function("module", "objFct", "record", "nv", 'file', 'response', 'fileList', chgLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.onChange = $chgLsn;
        }
        inputprops.onChange = (info) => {
            this.handleChange(info);//处理内部change事件
            let { file, fileList } = info;
            let status = file.status;//uploading done error removed

            if (status === "done" || status === "removed" || status === "error") {//上传成功、删除、失败
                SgiEventHandler.onChange.call(this, this, info);
            }
            // var chgLsn = moduleDesc.chgLsn; // 用户自定义点击事件
            // if (chgLsn) {
            //     var $chgLsn;
            //     try {
            //         $chgLsn = new Function("module", "objFct", 'file', 'fileList', 'response', "nv", chgLsn);
            //     } catch (error) {
            //         sgiLogger.eventErr(error);
            //     }
            //     // functions.onChange = $chgLsn;
            //     if (status === "done" || status === "removed" || status === "error") {//上传成功、删除成功
            //         $chgLsn(this, objFct, file, fileList, file.response, (file.response) ? (file.response.fileDownloadUri) : null);//处理自定义修改事件
            //     }
            // }
        }

        //上传前事件
        var bfrUpld = moduleDesc.bfrUpld; // 用户自定义上传前事件
        if (bfrUpld) {
            var $bfrUpld;
            try {
                $bfrUpld = new Function("module", "objFct", 'file', 'fileList', bfrUpld);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.beforeUpload = $bfrUpld;

            inputprops.beforeUpload = (file, fileList) => {
                // if (_beforeUpload && typeof _beforeUpload === "function") {
                let { moduleDesc, bdInst, objFct, type } = this.props;
                let rBoolen = $bfrUpld(this, objFct, file, fileList);
                if (typeof rBoolen === "boolean") {
                    return rBoolen;
                }
                return true;
                // }
            }
        }

        // fileClick 上传后的文件列表点击事件
        var fileClick = moduleDesc.fileClick; // 用户自定义上传前事件
        if (fileClick) {
            var $fileClick;
            try {
                $fileClick = new Function("module", "objFct", 'file', fileClick);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.onPreview = $fileClick;

            inputprops.onPreview = (file) => {
                // if (_fileClick && typeof _fileClick === "function") {
                let { moduleDesc, bdInst, objFct, type } = this.props;
                let rBoolen = $fileClick(this, objFct, file);
                if (typeof rBoolen === "boolen") {
                    return rBoolen;
                }
                return true;
                // }
            }
        }
        // let _beforeUpload = functions.beforeUpload;
    }



    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    AddInputAttribute(moduleDesc, formItem, inputprops, buttonProps) {

        this.state.types = [];
        const { previewVisible, previewImage, fileList } = this.state;

        var btnN = moduleDesc.btnN; // 按钮名称
        if (btnN) inputprops.btnN = btnN;

        // 关闭按钮图标 ?? 什么意思
        var closeI = moduleDesc.closeI;

        var cluW = moduleDesc.cluW;// 按钮宽度
        if (cluW) buttonProps.style.width = cluW;

        // 文件图标
        var fileNameI = moduleDesc.fileNameI;

        var iconPh = moduleDesc.iconPh;  // 按钮图标
        if (iconPh) inputprops.iconPh = iconPh;

        var mulSel = moduleDesc.mulSel;  // 设置是否允许多选
        if (mulSel) inputprops.multiple = mulSel;

        //只读，通过禁用就可以形式实现
        var isRead = moduleDesc.isRead;

        inputprops.action = sgiConfig.fileAction;//使用统一文件上传服务器，由配置文件决定
        // 支持自定义文件地址
        var action = moduleDesc.action;//上传文件地址
        if (action) inputprops.action = action;

        inputprops.headers = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};

        if (!inputprops.headers) inputprops.headers = {};
        // var bussType = moduleDesc.bussType;//所属项目路径
        // if (bussType) inputprops.headers.bussType = bussType;
        inputprops.headers.bussType = sgiConfig.bussType;//使用统一项目路径，由配置文件决定

        var accept = moduleDesc.accept;//接受文件类型
        if (accept) inputprops.accept = accept;
        else inputprops.accept = undefined;

        var isDrag = moduleDesc.isDrag;  // 是否拖拽样式
        inputprops.isDrag = !!isDrag;

        var nLimit = moduleDesc.nLimit;  // 数量限制
        inputprops.nLimit = nLimit;

        var isHdnLst = moduleDesc.isHdnLst;  // 是否隐藏上传列表
        inputprops.showUploadList = !isHdnLst;

        var isButton = moduleDesc.isBttn;  // 是否作为普通按钮
        this.state.isButton = !!isButton;
        if (!inputprops.style) inputprops.style = {};
        if (!!isButton) {//补充缺少的宽度
            inputprops.style.width = moduleDesc.ctlW;
        } else {
            inputprops.style.width = undefined;
        }

        // 达到数量上限是否隐藏上传
        this.state.hdUpld = !!moduleDesc.hdUpld;

        //显示类型
        var disType = moduleDesc.disType;
        if (!disType) {
            this.state.types.push(
                <Button {...this.state.buttonProps}>
                    <Icon type={iconPh} />{this.state.inputprops.btnN}
                </Button>);

        } else if ("picture-card" == disType) {

            inputprops.listType = disType;
            inputprops.onPreview = this.handlePreview;
            this.state.types.push(
                <div>
                    <Icon type={"plus"} />
                    <div className="ant-upload-text">{this.state.inputprops.btnN}</div>
                </div>
            );
        } else {
            inputprops.listType = disType;
            this.state.types.push(
                <Button {...this.state.buttonProps}>
                    <Icon type={iconPh} />{this.state.inputprops.btnN}
                </Button>);
        }
    }

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = file => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
            previewAlt: file.name
        });
    };

    handleChange = ({ file, fileList }) => {
        let status = file.status;

        //数量限制
        let n = this.state.inputprops.nLimit;
        if (n) {
            fileList = fileList.slice(-n);
        }

        this.state.inputprops.fileList = fileList;

        this.setState({ loading: false });
    };

    cvtShowList = () => {
        let value = this.state.inputprops.value;
        let files = [];
        if (value && (typeof value === "string")) {
            let fs = value.split(",");
            fs.forEach((f, index) => {
                let fileName;
                if (f.indexOf("/") > 0)
                    fileName = f.substring(f.lastIndexOf("/") + 1, f.length);
                else
                    fileName = f;
                let file = {
                    uid: index,//必须要有uid
                    url: f,
                    name: fileName,
                    status: "done"
                };
                files.push(file);
            });
        }

        //数量限制
        let n = this.state.inputprops.nLimit;
        if (n) {
            files = files.slice(-n);
        }

        this.state.inputprops.fileList = files;
    }

    getFileList = () => {
        //重组fileList数组，只返回有用信息
        let fileList = [];
        let stateFileList = this.state.inputprops.fileList;
        stateFileList.forEach(f => {
            let response = f.response || {};
            let file = {
                url: response.fileDownloadUri || f.url,
                fileName: response.fileName || f.name,
                fileType: response.fileType || f.type,
                status: f.status
            };
            fileList.push(file);
        });
        return fileList;
    }

    setFileList = (fileList) => {
        if (fileList && fileList.length >= 0) {
            this.state.inputprops.fileList = fileList;
            this.setState({ loading: true });
        }
    }

    setAction(url) {
        if (url) {
            this.state.inputprops.action = url;
        }
        this.setState({ loading: false });
    }

    setHeader(headers) {
        if (headers) {
            for (var key in headers) {
                this.state.inputprops.headers[key] = headers[key];
            }
        }
        this.setState({ loading: false });
    }

    //渲染并返回一个虚拟DOM
    render = function () {
        const { previewVisible, previewImage, previewAlt } = this.state;

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.upload_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;

            //回显value
            this.cvtShowList();
        }

        //修改button的禁用属性  跟随主控件
        if (this.state.isButton) {
            let button = this.state.types[0];
            button.key = uuid(8);
            button.props.disabled = this.state.inputprops.disabled;
        }

        // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
        const { _inputProps, _formItemProps } = this.getReviseProps();
        const { isLabel } = _inputProps;

        // 渲染前通用处理，如自定义样式等
        this.renderBeforeReturn();

        // 是否隐藏上传
        let n = this.state.inputprops.nLimit;
        let fileList = this.state.inputprops.fileList;
        let hidFlg = false;
        if (n && fileList && fileList.length >= n) {
            hidFlg = true;
        }

        let modal = <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel} >
            <img alt={previewAlt} style={{ width: '100%' }} src={previewImage} />
        </Modal>;

        let ctl = (isLabel)
            ? <span {...this.state.inputprops} {..._inputProps} >{this.state.inputprops.value}</span>
            : this.state.inputprops.isDrag
                ?
                <Dragger {...this.state.inputprops} {..._inputProps} className={hidFlg ? "sgi-upload-dragger-hidden" : null}>
                    <p className="ant-upload-drag-icon">
                        <Icon type="inbox" />
                    </p>
                    <p className="ant-upload-text">单击或拖动文件到此区域进行上传</p>
                    <p className="ant-upload-hint">支持单个或批量上传</p>
                    {/* {modal} */}
                </Dragger>
                :
                <Upload {...this.state.inputprops} {..._inputProps} >
                    {hidFlg || this.state.formItemProps.style.display === "none" ? null : this.state.types}
                    {/* {modal} */}
                </Upload>;

        let fCtl = this.state.noFI ? <div>{ctl}{modal}</div> : <FormItem {...this.state.formItemProps} {..._formItemProps}>{ctl}{modal}</FormItem>;

        return (
            this.state.isButton ?
                <Upload {...this.state.formItemProps}{...this.state.inputprops} {..._inputProps}>
                    {hidFlg || this.state.formItemProps.style.display === "none" ? null : this.state.types}
                </Upload>
                : fCtl
        );
    }
}

    //给类添加公共方法
    Object.assign(SgiFormUpload.prototype, sgiFormCtlBaseFun);

    //重写setValue方法 加入转换
    SgiFormUpload.prototype.setValue = function (value) {
    //更新state
    if (value === this.state.inputprops.value) {
    return;
}
    this.state.inputprops.value = value;

    //回显value
    this.cvtShowList();

    //页面校验
    this.validate(value);

    // var { moduleDesc, bdInst, objFct, type } = this.props;
    // let attname = moduleDesc.c
    // //刷新对象工厂值
    // if (bdInst && attname) {
    //     let bdInstData = objFct.get(bdInst);
    //     bdInstData[attname] = value;
    // }
}

export { SgiFormUpload };
export default SgiFormUpload;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiFormUpload.js